import React from "react";
import { FormattedMessage } from "react-intl";

export interface IFieldValidationErrorMessageProps {
  code: string;
  serverSideErrorMessage: string;
}
export const FieldValidationErrorMessage = ({
  code,
  serverSideErrorMessage,
}: IFieldValidationErrorMessageProps) => {
  if (code === "INVALID_CSV_HEADER") {
    const regex = new RegExp("^(.+?) is invalid.$");
    const csvHeaderMatches = serverSideErrorMessage.match(regex);
    if (csvHeaderMatches) {
      return (
        <FormattedMessage
          id="fetch.error.invalidCSVHeader"
          values={{ csvHeaderName: csvHeaderMatches[1] }}
        />
      );
    }
  }
  return <>{serverSideErrorMessage}</>;
};
